// src/firebase/firebase.js
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase-Konfigurationsdaten
const firebaseConfig = {
    apiKey: "AIzaSyAtcA6ptyvc5CZfm5XLLbBcQZr4TO7qLr0",
    authDomain: "sirius-dashboard.firebaseapp.com",
    projectId: "sirius-dashboard",
    storageBucket: "sirius-dashboard.firebasestorage.app",
    messagingSenderId: "337487702762",
    appId: "1:337487702762:web:70dc0bd9263b3bcd430593"
};

// Überprüfen, ob bereits eine App initialisiert wurde
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Dienste initialisieren
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();

// Persistenz auf `local` setzen (Benutzer bleibt auch nach Schließen des Browsers eingeloggt)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Persistenz auf local gesetzt');
  })
  .catch((error) => {
    console.error('Fehler beim Setzen der Persistenz:', error);
  });

export { auth, db, provider, storage };